import { atom } from "recoil";

const whyLinkAtom = atom({
  key: "whyLinkState",
  default: false,
});

export default whyLinkAtom;
